module.exports = __webpack_public_path__ + "img/email-stroke-icon.3a72aab0.png";